import React from 'react';
import StepHistory from "../../../../components/Ui/StepHistory/StepHistory";
import axios from "axios";
import {LOAD_STATE_HISTORIES} from "../../../../api/Api";
import {FICHE_STATES} from "../../../../utils/constants";
import moment from "moment";


function getHistoryAborescence(targetState, currentPath, allStates, histories, currentState, called = 1){

    function getState(state){
        return allStates.find((stateItem) => stateItem.state == state);
    }

    function getStateDoneInfo(state){

        const stateDoneInfo  = histories.find(
            historyItem => {
                return historyItem.new_state == state && historyItem.societe?.toUpperCase() == targetState.toUpperCase()
            }
        );

        return stateDoneInfo
    }

    const currentStateObject = getState(currentState);

    const nextStatesObject = currentStateObject.nextSteps || currentStateObject[`nextSteps${targetState.toUpperCase()}`];

    const nextDoneState = nextStatesObject?.map((nextState)=>{

        const state = getState(nextState.state);
        const stateDone = getStateDoneInfo(nextState.state);

        return {
            ...nextState,
            stateDone,
        }
    }).find(item=>!!item.stateDone) || nextStatesObject?.find(
        nextState => !!nextState.default
    );


    const currentStateDone = getStateDoneInfo(currentStateObject.state);


    currentPath.push({
        ...currentStateObject,
        stateDone: currentStateDone,
        isDone: !!currentStateDone,
        hours: currentStateDone ? moment(currentStateDone.created_at).format('DD/MM/Y') : undefined
    });

    console.log(currentStateObject)

    if(nextDoneState) {
        console.log('next done state', nextDoneState);
        if(called < 25)
        return getHistoryAborescence(targetState, currentPath, allStates, histories, nextDoneState.state, called + 1);
    }

    return currentPath;
}


export default function FicheHistoryStepper(props){

    const {histories, targetState} = props;

    //Construire le fil de progression.
    /**

       On utilise une méthode qui prend en paramètre l'historique réel est le tableau de tous les états.
        La fonction d'élaboration du file de progression s'appel lu même de manière interne jusqu'a retourné le fil complet.
     A chaque appel il prend les possibles etats en sortie selon l'état cible, si l'état cible n'est pas la, il vas cherché dans l'état générique.
     Si celui aussi n'est pas la, on considère qu'on a obtenue le fil complet.
     A chaque étape de la construction de l'arbre, on indique si le client a passé l'étape ou non.


     */

    const ficheHistories = React.useMemo(
        ()=>{
            if(histories)
                return getHistoryAborescence(targetState, [], FICHE_STATES, histories, 'App\\Models\\Fiches\\States\\FicheTransmittedStep')

            else
                return [];
        },[histories]
    );

    console.log('fiche histories', ficheHistories);

    return (
        <StepHistory histories={ficheHistories} />
    );
}